enum Prefixes {
  agent = '(Agent)'
}

export enum SmartLookEventEnum {
  MAX_AGE_EXCEEDED = 'Max Age Exceeded',
  LEAD_FORM_OPENED = 'Lead Form Opened',
  LEAD_CREATED = 'Lead Created',
  MIXED = 'Mixed Customer Without Login',
  EXISTING = 'Existing Customer Without Login'
}

export function agentPrefix(isAgent: boolean, event: string): string {
  return `${isAgent ? `${Prefixes.agent} ` : ''}${event}`;
}
